import React from "react";

interface IProps {
    desktop_image?: string;
    mobile_image?: string;
}

interface IState {
    isMobile: boolean;
}

// TODO(ssr, LEVEL 4 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 4/10 due to window resize listener in componentDidMount, simple state management, and responsive image switching logic.
export class OrderOfferImage extends React.Component<IProps, IState> {
    public state: IState = {
        isMobile: false,
    };

    componentDidMount() {
        window.addEventListener("resize", () => {
            this.isWindowResizing();
        });
    }

    private isWindowResizing() {
        if (window.innerWidth <= 500) {
            this.setState({
                isMobile: true,
            });
        } else {
            this.setState({
                isMobile: false,
            });
        }
    }

    render() {
        const backgroundImage = this.state.isMobile
            ? this.props.mobile_image
            : this.props.desktop_image;
        return (
            <div
                style={{ backgroundImage: `url('${backgroundImage}')` }}
                className="thank-you-order-offer__container"
            ></div>
        );
    }
}
